import React from 'react';
import * as Icons from '@beamery/lib-ds-icons';
export function TextIcon({ iconName, fontSize = 'm', ...props }) {
    if (!iconName)
        return null;
    const Icon = Icons[iconName];
    const iconSize = {
        xs: 'small',
        s: 'standard',
        m: 'standard',
        l: 'large',
        xl: 'large',
    };
    return React.createElement(Icon, { size: iconSize[fontSize], ...props });
}
//# sourceMappingURL=text-icon.component.js.map